import ReactMarkdown from 'react-markdown';
const Privacy = () => {
  const content = `

# Privacy Policy

**Last Updated:** January 14, 2026

SolveClip (“**SolveClip**”, “**we**”, “**our**”, or “**us**”) is an AI-powered platform operated by **Littlelights US Corporation**that enables users to generate short explanatory videos based on text and image inputs.

We respect your privacy and are committed to protecting it through this Privacy Policy. This policy explains how we handle information when you use the SolveClip website and related services (collectively, the “**Service**”).

---

## 1. Information We Collect

### 1.1 User Account Information

When you create an account or log in to SolveClip, we may collect:

- Basic account credentials (such as email address or authentication identifiers)
- Login-related technical information necessary to provide account access

We do **not** require users to provide real names, profile details, or other personal identity information.

### 1.2 User Input Content

SolveClip allows users to input text and images for the purpose of generating AI-based explanatory videos.

- User input content is processed **only to generate the requested video**
- We do **not** permanently store user input content
- We do **not** use user input content to build user profiles or for advertising purposes

### 1.3 Automatically Collected Information

Like most web services, we may automatically collect limited technical data, such as:

- Device type and browser information
- IP address (used only for security, fraud prevention, and basic analytics)
- General usage logs (e.g., feature usage, error logs)

This information is used solely to operate, maintain, and improve the Service.

---

## 2. How We Use Information

We use collected information only for the following purposes:

- To provide and operate the SolveClip Service
- To process user requests and generate AI videos
- To maintain account authentication and security
- To improve system performance and reliability
- To comply with applicable legal obligations

We do **not** sell, rent, or trade user information.

---

## 3. Data Storage and Retention

- User input content (text or images) is **not retained** after video generation
- Account-related data is retained only as long as necessary to provide the Service
- Technical logs are retained for a limited period for security and operational purposes

---

## 4. Sharing of Information

We do **not** share user data with third parties except:

- When required to operate core infrastructure (e.g., cloud hosting, AI model services)
- When required by law, regulation, or legal process
- To protect the rights, safety, or security of SolveClip, our users, or the public

All service providers are bound by confidentiality and data protection obligations.

---

## 5. International Users

SolveClip is operated by **Littlelights US Corporation** and is available to users worldwide.

If you access the Service from outside the United States, you understand that your information may be processed in the United States or other jurisdictions where our service providers operate.

---

## 6. Children’s Privacy

SolveClip is not intended for children under the age of 13.

We do not knowingly collect personal information from children.

If you believe a child has provided us with personal information, please contact us so we can take appropriate action.

---

## 7. Security

We implement reasonable technical and organizational measures to protect information against unauthorized access, loss, misuse, or alteration.

However, no internet-based service can be guaranteed to be 100% secure.

---

## 8. Your Rights

Depending on your location, you may have rights to:

- Access or update your account information
- Request deletion of your account
- Object to or restrict certain data processing

You may exercise these rights by contacting us using the information below.

---

## 9. Changes to This Policy

We may update this Privacy Policy from time to time.

Any changes will be posted on this page with an updated “Last Updated” date.

---

## 10. Contact Us

If you have any questions about this Privacy Policy or our data practices, please contact us at:

**Littlelights US Corporation**

📧 Email:`;
  return (
    <div className="markdown-body">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};
export default Privacy;
